//imports
import React, {useEffect, useMemo, useRef, useState} from 'react';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';

//controls
import {Grid} from '@mui/material';
import Modal, {ModalBody, ModalFooter} from 'Components/Modal';
import {Button, Form, Input, Pill, Select, Stepper} from 'Components';
import {NotificationManager} from 'Components/Notifications';
import {FtpForm} from "Modules/reports/views/main/components/ftpForm";
import { LogManagerConsole } from 'Core/logManager';
import TagsManage from "Modules/.common/components/TagsManage";

//Hooks
import {useCustomTimeRange, useInput, useNewEntityTag, useReportCustomFields, useReportTypeOptions, useRealtimeTags} from 'Core/hooks';

// actions
import {catalogLoad, clearRedux, getSchedules, getServiceItemsLegacy, reportsScheduleHideReportSetup, saveSchedule, updateSchedule, updateSubscribers} from 'Redux/actions';

import {searchDynamicForms} from './../../../../../../../dynamicForms/views/main/components/forms/redux/slice.js';
import EntityUnitDriverSelector from "Modules/.common/components/EntityUnitDriverSelector";
//styles
import styles from "Assets/sass/core/vars.scss";
import './reportSetup.scss';
// import TagFilter from "Modules/.common/components/TagFilter";
import FrequencyStep from './.components/frequencySetup';
import ReportCustomFields from '../../../reportCustomFields';
import {validateReportTypePermissions, validCustomFilters} from '../../../../../../.globals/helpers';
import {getListHasVideoEvents} from "Modules/video/views/main/redux/slice";

const handleChangeDay = ( days , value ) => {
    const newSelectedDays = [ ...days ];
    const index = newSelectedDays.indexOf( value );
    if ( index > -1 ) {
        // If the day already exists, remove it
        newSelectedDays.splice( index , 1 ); // 2nd parameter means remove one item only
    } else {
        newSelectedDays.push( value )
    }
    return newSelectedDays;
}

const ID_ALL_ENTITIES = "-99";
const ReportSetup = ( props ) => {
    const {messages, locale, refClearReportSetup} = props;
    const dispatch = useDispatch()
    const frequencyOptions = [ { id : 'daily' , label : messages['reportsMainST_daily'] } , { id : 'weekly' , label : messages['reportsMainST_weekly'] } , {
        id : 'monthly' ,
        label : messages['reportsMainST_monthly']
    } , ]

    const { currentSchedule , savedSchedule , updatedSchedule , loading , showReportSetup , subscribersResponse } = useSelector( ( state ) => state.reportsSetupModal );

    const user = useSelector( state => state.securityRedux.user );

    const selectOptions = useRef();
    const [ numberTab , setNumberTab ] = useState( 0 );
    const [ errorCustomFilters , setErrorCustomFilters ] = useState( false )
    const inputNameSchedule = useInput( '' , messages['reportsMainST_nameOfSchedule'] , messages['reportsMainST_nameOfSchedulePlaceholder'] );
    const defaultDeliverAtTime = useMemo(() => {
        const date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
    }, []);
    const inputDeliverAt = useInput( defaultDeliverAtTime , messages['reportsMainST_deliveredAt'] , messages['reportsMainST_deliveredAt'] );
    const [ deliveredOnMonthly , setDeliveredOnMonthly ] = useState();


    const [ formData , setFormData ] = useState( null );
    const [ subscribers , setSubscribers ] = useState( [] )

    const [ itemsError , setItemsError ] = useState( false )
    const [ reportType , setReportType ] = useState()
    const [ frequency , setFrequency ] = useState( frequencyOptions[0].id );
    const [ selectedDays , setSelectedDays ] = useState( [] );
    const [ deliverOn , setDeliverOn ] = useState( [] );
    const [ includeInactiveDrivers , setIncludeInactiveDrivers ] = useState( false )

    // is used to Custom time range state
    const { dataCustomTimeRange , validateCustomTimeRanges , setStateCustomTimeRange } = useCustomTimeRange();

    // is used to know when the items in the entity selector are collapsed
    const [ errorIncludeDates , setErrorIncludeDates ] = useState( false )
    const [ errorDeliveryAt , setErrorDeliveryAt ] = useState( false )
    const [ errorDeliveryOnMonthly , setErrorDeliveryOnMonthly ] = useState( false )
    const [ errorDeliverOn , setErrorDeliverOn ] = useState( false )
    const entities = [ { id : "Unit" , label : messages['units'] } , { id : "Driver" , label : messages['drivers'] } ];

    // Data Ftp Send
    const [ ftp , setFtp ] = useState( {} )
    const [ validFtp , setValidFtp ] = useState( false )

    const filters = useSelector( state => state.dynamicFormsRedux.filters );
    const dynamicForms = useSelector( state => state.dynamicFormsRedux.data );

    const [ delivery , setDelivery ] = useState( "pdf" )
    const reportTypeOptions = useReportTypeOptions( user ).reportTypeOptions;
    const validatePermissionsReportType = validateReportTypePermissions( reportTypeOptions , true );
    const entityTagsSchedule = useNewEntityTag( [ "Unit" , "Driver" ] , messages['entitySelect'] , "calc(100vh - 320px)" , messages['optionSelect'] , 'tags' )

    const serviceItems = useSelector( state => state.reportsMainRTRedux.serviceItems )
    const services = useSelector( state => state.catalogsRedux.maintenanceServicesItems );
    const contacts = useSelector( state => state.catalogsRedux.contacts );
    const timeZone = useSelector( state => state.securityRedux.user.timeZone );

    const { responseListEventsVideo } = useSelector( ( state ) => state.videoEventsRedux );
    const [ optionEventTypes , setOptionsEventTypes ] = useState( [] );
    const [allOptionEventTypes, setAllOptionsEventTypes] = useState([]);

    const [ orderContacts , setOrderContacts ] = useState( contacts )

    const VIEW_OPTIONS = [
        {id: 'pdf', name: messages['reportsMainST_pdf']},
        {id: 'csv', name: messages['reportsMainST_csv']},
        {id: 'json', name: messages['reportsMainST_web']},
        {id: 'ftp', name: messages['reportsMainST_ftp']}
    ];
    const [deliveryList, setDeliveryList] = useState(VIEW_OPTIONS)

    const tags = useRealtimeTags({ trackFields: ['id', 'label', 'disabled', 'tagPath', 'tags'] });
    const haveUntagged = tags?.find( t => t?.id == -1 ) ? true : false;

    const customFieldsReports = useReportCustomFields( haveUntagged )

    const optionsSelectReportType = useMemo( () => [ { id : "simple" , label : messages['exportBehavior_simpleReport'] } , {
        id : "detailed" ,
        label : messages['exportBehavior_detailedReport']
    } , ] , [ messages ] );

    useEffect( () => {
        if ( contacts && contacts.length ) {
            try {
                let arrayForSort = [ ...contacts ]
                const orderedContacts = arrayForSort.sort( compare );
                setOrderContacts( orderedContacts )
            } catch ( e ) {
                LogManagerConsole( `${ e }` )
            }
        }

    } , [ contacts ] )


    useEffect( () => {
        if ( responseListEventsVideo?.length ) {
            let transformedEvents = [ { key : 'all' , label : messages['generatedReport_allEvents'] } ]
            transformedEvents.push( ...responseListEventsVideo.map( event => {
                let key = event?.eventName.replace( /\s+/g , '' ).charAt( 0 ).toLowerCase() + event?.eventName.replace( /\s+/g , '' ).slice( 1 );
                let label = messages[`videoMainView_${ key }`] ? messages[`videoMainView_${ key }`] : event?.eventName
                return { key , label, name: event?.eventName}
            } ) )
            setOptionsEventTypes( transformedEvents )
            setAllOptionsEventTypes([...transformedEvents.map((option) => {return {id: option.key, label: option.label, name: option.name} }), ...customFieldsReports.selectEventTypeOptions])
        } else {
            setAllOptionsEventTypes([{ id: "Main Power Disconnect", label: messages['generatedReport_mainPowerDisconnect'] }, { id : 'all' , label : messages['generatedReport_allEvents'] }, ...customFieldsReports.selectEventTypeOptions])
        }
    }, [responseListEventsVideo, locale]);


    useEffect( () => {
        dispatch( getListHasVideoEvents( {} ) )
    } , [] );

    useEffect( () => {
        if ( savedSchedule ) {
            if ( subscribers?.length ) {
                addAlerts( savedSchedule.id )
            } else {
                showSuccess()
                dispatch( getSchedules( messages , timeZone ) );
                setNumberTab( 0 )
                handleCancel();
            }
        }
    } , [ savedSchedule ] );

    useEffect( () => {
        if ( updatedSchedule ) {

            if ( subscribers?.length ) {
                dispatch( clearRedux( "REPORTS_MAIN_ST" , { updatedSchedule : false } ) )
                addAlerts( currentSchedule.id )
            } else {
                showSuccess()
                handleCancel();
            }

            dispatch( getSchedules( messages , timeZone ) );
        }
    } , [ updatedSchedule ] );


    useEffect( () => {
        if ( subscribersResponse ) {
            dispatch( clearRedux( "REPORTS_MAIN_ST" , { subscribersResponse : false } ) )
            showSuccess()
            dispatch( getSchedules( messages , timeZone ) );
            handleCancel()
        }
    } , [ subscribersResponse ] );

    useEffect( () => {
        if ( showReportSetup ) {
            dispatch( catalogLoad( [ 'contacts' ] ) );
        }

    } , [ showReportSetup ] )

    useEffect( () => {
        if ( currentSchedule ) {
            let scheduleType;
            validatePermissionsReportType.find( reportT => {
                reportT?.options?.map( newReport => {
                    if ( newReport.id === currentSchedule.reportType ) {
                        scheduleType = { ...newReport }
                    }
                } )
            } );

            // set custom Filters ||
            if ( scheduleType ) {
                inputNameSchedule.onChange( currentSchedule.name )
                const currentDeliveryAt = getDeliveryAt( currentSchedule.deliveryAt )
                setReportType( scheduleType )
                setFrequency( currentSchedule.frequency )
                setSelectedDays( currentSchedule.weekDays )
                inputDeliverAt.onChange( currentDeliveryAt )
                if ( currentSchedule.frequency == "monthly" ) {
                    const newDeliveryOnMonthly = deliveryOnList.find( deliver => deliver.label == currentSchedule.deliveryOn )
                    setDeliveredOnMonthly( newDeliveryOnMonthly )
                } else {
                    setDeliverOn( currentSchedule.deliveryOn )
                }

                if ( scheduleType?.hideUnits ) {
                    entityTagsSchedule.hideUnits()
                } else {
                    entityTagsSchedule.showAll()
                }

                if ( currentSchedule.category?.categoryName === 'Driver' ) {
                    let { UIParams } = currentSchedule;
                    try {
                        UIParams = JSON.parse( JSON.parse( UIParams ) )
                    } catch ( e ) {
                    }
                    if ( UIParams?.filters?.includeInactiveDrivers ) {
                        entityTagsSchedule.onOptionChangeStatus( UIParams?.filters?.includeInactiveDrivers )
                    }
                    setIncludeInactiveDrivers( UIParams?.filters?.includeInactiveDrivers );
                } else {
                    setIncludeInactiveDrivers( false )
                }
                ;

                if ( currentSchedule.category?.categoryName ) {
                    entityTagsSchedule.onChangeEntity( { id : currentSchedule.category?.categoryName } )
                }

                if ( currentSchedule.selectAll ) {
                    const type = currentSchedule.category?.entities[0].type || currentSchedule.category?.entities[0].__typename
                    if ( type === 'Tag' ) {
                        entityTagsSchedule.onOptionChange( { id : 'tags' } )
                        const defaultAllTags = [ {
                            "id" : -99 , "type" : "Tag"
                        } ];
                        entityTagsSchedule.onChange( defaultAllTags )
                        setFormData( { ...formData , tags : [ ...defaultAllTags ] } )
                    } else {
                        entityTagsSchedule.onOptionChange( { id : 'all' , label : 'All Units' } )
                    }
                } else {
                    const newSelectedItems = currentSchedule.category?.entities?.map( entity => ( { ...entity , name : entity.type || entity.name , label : entity.label } ) )
                    if ( newSelectedItems[0]?.name === 'Tag' ) {
                        entityTagsSchedule.onOptionChange( { id : 'tags' , label : 'Tags' } )
                    } else {
                        entityTagsSchedule.onOptionChange( { id : 'entities' , label : 'Single Units' } )
                    }

                    entityTagsSchedule.onChange( newSelectedItems )
                    setFormData( { ...formData , tags : [ ...newSelectedItems ] } )

                }

                let newSubscribers = currentSchedule.subscribers.map( subscriber => subscriber.contact )
                newSubscribers = newSubscribers.filter( sub => {
                    // select options with values
                    if ( sub ) {
                        return true
                    }
                    return false;
                } )
                setSubscribers( newSubscribers )

                //Validating the schedule if format is CSV in FTP
                if ( currentSchedule?.ftpHost?.length > 0 && currentSchedule.format == 'csv' ) {
                    const { ftpHost } = currentSchedule;
                    setFtp( ftpHost )
                    setDelivery( "ftp" )
                } else {
                    setDelivery( currentSchedule.format )
                }

                if ( scheduleType?.id === 'idleReport' ) {
                    let { UIParams } = currentSchedule;
                    try {
                        UIParams = JSON.parse( JSON.parse( UIParams ) )
                    } catch ( e ) {
                    }
                    customFieldsReports.onChangeOtherFilters( {
                        ...customFieldsReports.otherFilters , minute : currentSchedule.integerRanges[0]?.GTE , checkIdleProductive : UIParams?.filters?.otherFilters?.checkIdleProductive || false
                    } )
                } else if ( [ 'stopReport' , 'movingReport' ].includes( scheduleType.id ) ) {
                    let variables = { minute : currentSchedule.integerRanges[0]?.GTE }
                    if ( [ 'stopReport' ].includes( scheduleType.id ) ) {
                        const booleanValue = currentSchedule.filterValues ? currentSchedule.filterValues[0]?.booleanValue : false
                        variables = { ...variables , excludeIdle : booleanValue }
                    }
                    customFieldsReports.onChangeOtherFilters( { ...customFieldsReports.otherFilters , ...variables } )

                } else if ( [ 'formStopSummaryReport' , 'formStopSummaryReportV2' ].includes( scheduleType.id ) ) {
                    if ( [ 'formStopSummaryReportV2' ].includes( scheduleType.id ) && dynamicForms?.items?.length == 0 ) {
                        dispatch( searchDynamicForms( { ...filters , limit : 0 } ) );
                    }
                    const formId = currentSchedule.stringValues[0]?.values[0];
                    let variables = { minute : currentSchedule.integerRanges[0]?.GTE , form : formId , formView : formId == 1 ? "all" : "single" }
                    customFieldsReports.onChangeOtherFilters( { ...customFieldsReports.otherFilters , ...variables } )
                } else if ( scheduleType.id === 'speedReport' ) {
                    customFieldsReports.onChangeOtherFilters( {
                        ...customFieldsReports.otherFilters , speed : currentSchedule.integerRanges[0]?.GTE || 0 , speedLimitDelta : ( currentSchedule.integerRanges[1]?.LTE ?? 0 )
                    } )
                } else if ( scheduleType.id === 'latitudeLongitudeReport' ) {
                    customFieldsReports.onChangeOtherFilters( { ...customFieldsReports.otherFilters , eventInterval : currentSchedule.integerRanges[0]?.GTE || 0 } )
                } else if ( [ 'vehServiceItemsReport' ].includes( scheduleType.id ) ) {
                    customFieldsReports.onChangeOtherFilters( { ...customFieldsReports.otherFilters , event : currentSchedule.stringValues[0]?.values[0] } )
                } else if ( [ 'eventReport' ].includes( scheduleType.id ) ) {
                    if (!optionEventTypes.length){
                        let transformedEvents = [ { key : 'all' , label : messages['generatedReport_allEvents'] } ]
                        if ( responseListEventsVideo?.length ) {
                            transformedEvents.push( ...responseListEventsVideo.map( event => {
                                let key = event?.eventName.replace( /\s+/g , '' ).charAt( 0 ).toLowerCase() + event?.eventName.replace( /\s+/g , '' ).slice( 1 );
                                let label = messages[`videoMainView_${ key }`] ? messages[`videoMainView_${ key }`] : event?.eventName
                                return { id: key , label, name: event?.eventName }
                            } ) )
                            setOptionsEventTypes( transformedEvents )
                        } else {
                            transformedEvents.push({ id: "Main Power Disconnect", label: messages['generatedReport_mainPowerDisconnect'] })
                        }

                        let filterEventsSelected =  currentSchedule.stringValues[0]?.values.map( event => {
                            return [...transformedEvents, ...customFieldsReports.selectEventTypeOptions].find(type => [camelCaseToTitle(event), toCamelCase(event), event].includes(type.id))
                        } );

                        customFieldsReports.onChangeOtherFilters( {
                            ...customFieldsReports.otherFilters , eventTypes : currentSchedule.stringValues[0]?.values.length ? filterEventsSelected : [ { id : 'all' , label : '' } ], allVideoEvents: optionEventTypes
                        } )
                    } else {
                        let filterEventsSelected =  currentSchedule.stringValues[0]?.values.map( event => {
                            return [...optionEventTypes.map((option) => {return {id: option.key, label: option.label} }), ...customFieldsReports.selectEventTypeOptions].find(
                                type => [camelCaseToTitle(event), toCamelCase(event), event].includes( type.id
                                ))
                        } );

                        customFieldsReports.onChangeOtherFilters( {
                            ...customFieldsReports.otherFilters , eventTypes : currentSchedule.stringValues[0]?.values.length ? filterEventsSelected : [ { id : 'all' , label : '' } ], allVideoEvents: []
                        } )
                    }
                }else if ( [ 'driverCoachingReport' ].includes( scheduleType.id ) ) {
                    customFieldsReports.onChangeOtherFilters( {
                        ...customFieldsReports.otherFilters , eventTypes : currentSchedule.stringValues[0]?.values.length ? currentSchedule.stringValues[0]?.values.map( event => {
                            return optionEventTypes.find( type => type.key === toCamelCase(event) )
                        } ) : [ { key : 'all' , label : '' } ]
                    } )
                } else if ( [ 'driverFormsReport' , 'driverFormsReportV2' ].includes( scheduleType.id ) ) {
                    const valueForm = currentSchedule.stringValues[0]?.values?.length > 1 ? 1 : currentSchedule.stringValues[0]?.values[0];
                    customFieldsReports.onChangeOtherFilters( { ...customFieldsReports.otherFilters , form : valueForm } )
                } else if ( scheduleType.id === 'behaviorReport' ) {
                    const valueForm = currentSchedule.stringValues[0]?.values?.length > 1 ? 1 : currentSchedule.stringValues[0]?.values[0];
                    const valueFormReportType = currentSchedule.filterValues[0]?.entities && currentSchedule.filterValues[0]?.entities[0]?.id ? currentSchedule.filterValues[0]?.entities[0]?.id : 'detailed';
                    customFieldsReports.onChangeOtherFilters( { ...customFieldsReports.otherFilters , risk : valueForm , reportType : valueFormReportType } )
                } else if ( scheduleType.id === 'fuelLevelReport' ) {
                    const value = currentSchedule.stringValues[0]?.values?.length < 1 ? 10 : currentSchedule.stringValues[0]?.values[0];
                    const valueFormReportType = currentSchedule.filterValues[0]?.entities && currentSchedule.filterValues[0]?.entities[0]?.id ? currentSchedule.filterValues[0]?.entities[0]?.id : '';
                    customFieldsReports.onChangeOtherFilters( { ...customFieldsReports.otherFilters , percentage : value , event : valueFormReportType } )
                } else if ( scheduleType.id === 'landmarkBasedReport' || scheduleType.id === 'landmarkSummaryReport' ) {
                    if ( currentSchedule.filterValues[0]?.field === 'Tag' ) {
                        customFieldsReports.onChangeOtherFilters( {
                            ...customFieldsReports.otherFilters ,
                            landmarkBaseView : 'tags' ,
                            landmarkTags : customFieldsReports.tags.find( tag => tag.id == currentSchedule.filterValues[0]?.entities[0]?.id )
                        } )
                    } else if ( currentSchedule.filterValues[0]?.field === 'Landmark' ) {
                        if ( currentSchedule.filterValues[0]?.entities && currentSchedule.filterValues[0]?.entities[0]?.id ) {
                            customFieldsReports.onChangeOtherFilters( {
                                ...customFieldsReports.otherFilters , landmarkBaseView : 'single' , landmark : currentSchedule.filterValues[0]?.entities[0]?.id
                            } )
                        } else {
                            customFieldsReports.onChangeOtherFilters( {
                                ...customFieldsReports.otherFilters , landmarkBaseView : 'all'
                            } )
                        }
                    }
                } else if ( scheduleType.id === 'geofenceBasedReport' ) {
                    if ( currentSchedule.filterValues[0]?.field === 'Tag' ) {
                        customFieldsReports.onChangeOtherFilters( {
                            ...customFieldsReports.otherFilters ,
                            geofenceBaseView : 'tags' ,
                            geofenceTags : customFieldsReports.tags.find( tag => tag.id == currentSchedule.filterValues[0]?.entities[0]?.id )
                        } )
                    } else if ( currentSchedule.filterValues[0]?.field === 'Geofence' ) {
                        if ( currentSchedule.filterValues[0]?.entities && currentSchedule.filterValues[0]?.entities[0]?.id ) {
                            customFieldsReports.onChangeOtherFilters( {
                                ...customFieldsReports.otherFilters , geofenceBaseView : 'single' , geofence : currentSchedule.filterValues[0]?.entities[0]?.id
                            } )
                        } else {
                            customFieldsReports.onChangeOtherFilters( {
                                ...customFieldsReports.otherFilters , geofenceBaseView : 'all'
                            } )
                        }
                    }
                }
            }
        }
    } , [ currentSchedule ] )

    const toCamelCase = (str) => {
        return str
            .toLowerCase()
            .replace(/'|"/g, '')
            .split(' ')
            .map((word, index) => {
                if (index === 0) return word;
                return word.charAt(0).toUpperCase() + word.slice(1);
            })
            .join('');
    }

    const camelCaseToTitle = (text) => {
        if (!text) return '';
        const result = text.replace(/([A-Z])/g, '$1');
        return result.charAt(0).toUpperCase() + result.slice(1);
    };

    const compare = ( a , b ) => {
        let titleA = a?.title?.toLowerCase();
        let titleB = b?.title?.toLowerCase();
        if ( titleA < titleB ) {
            return -1;
        }
        if ( titleA > titleB ) {
            return 1;
        }
        return 0;
    }

    const fillDeliverOnMonthly = () => {
        const deliverList = []
        const list = [ [ 1 , 11 , 21 , 31 ] , [ 2 , 12 , 22 ] , [ 3 , 13 , 23 ] ]
        let label;
        for ( let i = 1; i <= 31; i++ ) {
            if ( list[0].includes( i ) ) {
                label = 'st'
            } else if ( list[1].includes( i ) ) {
                label = 'nd'
            } else if ( list[2].includes( i ) ) {
                label = 'rd'
            } else {
                label = 'th'
            }


            if ( messages['reportsMainST_initialLetterMonday'] === 'M' ) {
                deliverList.push( {
                    id : i , label : `${ i }${ label }`
                } )
            } else {
                deliverList.push( {
                    id : i , label : `${ i }`
                } )
            }
        }


        return deliverList
    }

    const deliveryOnList = fillDeliverOnMonthly()
    // <---- Entity Selector Setup ---->


    const daysOptions = [ { id : 'monday' , label : messages['reportsMainST_initialLetterMonday'] } , { id : 'tuesday' , label : messages['reportsMainST_initialLetterTuesday'] } , {
        id : 'wednesday' ,
        label : messages['reportsMainST_initialLetterWednesday']
    } , { id : 'thursday' , label : messages['reportsMainST_initialLetterThursday'] } , { id : 'friday' , label : messages['reportsMainST_initialLetterFriday'] } , {
        id : 'saturday' ,
        label : messages['reportsMainST_initialLetterSaturday']
    } , { id : 'sunday' , label : messages['reportsMainST_initialLetterSunday'] } , ]

    //If your report needs to have an unassigned driver, add it to this list.
    const reportsUnassignedDriver = [ 'driverCoachingReport' ];

    const frequencyValidations = () => {
        if ( frequency ) {
            let error = false;
            if ( validateCustomTimeRanges() ) {
                setErrorIncludeDates( true )
                error = true;
            }

            if ( ! inputDeliverAt.value ) {
                setErrorDeliveryAt( true )
                error = true;
            }

            if ( frequency === 'weekly' ) {
                if ( deliverOn?.length === 0 ) {
                    setErrorDeliverOn( true );
                    error = true;
                }
            }

            if ( frequency === 'monthly' ) {
                if ( ! deliveredOnMonthly ) {
                    setErrorDeliveryOnMonthly( true )
                    error = true;
                }
            }

            if ( error ) {
                return false
            }
        }
        return true
    }

    const reportValidations = () => {
        return true
    }
    const showSuccess = () => {
        NotificationManager.success( updatedSchedule ? messages[`reportsMainST_scheduleUpdatedSuccessfully`] : messages[`reportsMainST_scheduleCreatedSuccessfully`] , messages['success'] , 3000 , null , null , 'Success' , );
    }
    //button back
    const handleBack = () => {
        if ( numberTab > 0 && ( numberTab <= 3 || numberTab <= 2 ) ) {
            setNumberTab( numberTab - 1 );
        }
    };
    //button next
    const handleSaveSchedule = () => {
        let entityValues = entityTagsSchedule?.values?.map( item => ( { id : item.id , type : item.name || item.type , label : item.label } ) ) || [];
        const field = entityTagsSchedule?.entity?.id == 'Driver' ? 'driverId' : 'deviceId';
        const info = {
            timeZone : user.timeZone ,
            filterEntity : entityTagsSchedule?.entity?.id ,
            reportType : reportType.id ,
            filterType : field ,
            filterArray : entityValues ,
            otherFilters : customFieldsReports.otherFilters ,
            exportType : delivery === "ftp" ? "csv" : delivery ,
            name : inputNameSchedule.value || '' ,
            categoryName : entityTagsSchedule?.entity?.id || '' ,
            frequency ,
            selectedDays ,
            ftpHost : delivery === "ftp" ? ftp : "" ,
            deliveryOn : frequency === 'monthly' ? [ deliveredOnMonthly.label ] : deliverOn ,
            deliveryAt : moment( inputDeliverAt.value || '' ).format( 'hh:mm A' ) ,
            scheduleTimeRanges : dataCustomTimeRange.filter(({ checked }) => checked).map(({ checked, ...rest }) => rest) , // only send the time ranges that are selected
            includeInactiveDrivers : entityTagsSchedule?.includeInactiveDrivers
        }
        if ( currentSchedule?.id ) {
            dispatch( updateSchedule( {
                ...info , id : currentSchedule.id , messages
            } ) );
        } else {
            dispatch( saveSchedule( {
                ...info , messages
            } ) );
        }

    }
    const handleNext = () => {
        setErrorCustomFilters( false );
        if ( numberTab >= 0 && numberTab < 3 ) {
            if ( numberTab === 0 ) {
                if ( reportValidations() ) {
                    setNumberTab( numberTab + 1 );
                }
            } else if ( numberTab === 1 ) {
                if ( frequencyValidations() ) {
                    setNumberTab( numberTab + 1 );
                } else {
                    validateCustomTimeRanges( true )
                }
            } else {
                setNumberTab( numberTab + 1 );
            }

        }

        if ( numberTab === 3 ) {
            handleSaveSchedule();
        }
    };

    const getDeliveryAt = ( deliveryAt ) => {
        if ( deliveryAt ) {
            const tempDeliverAt = moment().format( `YYYY-MM-DD` )
            const newDeliverAt = moment( `${ tempDeliverAt } ${ deliveryAt }` , `YYYY-MM-DD hh:mm A` ).toDate()
            if ( newDeliverAt ) {
                const result = new Date( newDeliverAt )
                return result
            }
        }

        return '';

    }

    const onChangeSelectDay = ( e ) => {
        setErrorIncludeDates( false )
        setErrorDeliveryAt( false )
        const newSelectedDays = handleChangeDay( selectedDays , e.target.value )
        setSelectedDays( newSelectedDays )
    }

    const onChangeDeliverOn = ( e ) => {
        const newSelectedDays = handleChangeDay( deliverOn , e.target.value )
        setDeliverOn( newSelectedDays )
        setErrorDeliverOn( false )
    }

    const onChangeDeliverOnMonthly = ( value ) => {
        setDeliveredOnMonthly( value );
        setErrorDeliveryOnMonthly( false );
    }

    const onChangeDeliveryAt = ( value ) => {
        inputDeliverAt.onChange( value );
        setErrorDeliveryAt( false )
    }


    const getFilterEntityFromEntity = ( entity ) => {
        switch ( entity ) {
            case 'deviceId':
                return 'Unit'
            case 'driverId':
                return 'Driver'
            case 'unitGroupId':
                return 'Unit'
            case 'driverGroupId':
                return 'Driver'
            default:
                return ''
        }
    }

    const handleCancel = () => {
        setStateCustomTimeRange( [] );
        setNumberTab( 0 )
        setDeliveredOnMonthly()
        setSubscribers( [] )
        setItemsError( false )
        entityTagsSchedule.onChangeEntity( entities[0] );
        entityTagsSchedule.onChange( [] );
        setReportType()
        setFrequency( frequencyOptions[0].id )
        setSelectedDays( [] )
        setDeliverOn( [] )
        setErrorIncludeDates( false )
        setErrorDeliveryAt( false )
        setErrorDeliverOn( false )
        setErrorDeliveryOnMonthly( false )
        customFieldsReports.restartOtherFilters();
        customFieldsReports.clear()
        setDelivery( "pdf" )
        inputNameSchedule.onChange( '' )
        inputDeliverAt.onChange( '' )
        setIncludeInactiveDrivers( false )
        dispatch( reportsScheduleHideReportSetup() )
    }
    const addAlerts = ( entityId ) => {
        let alertsForUpdate = []
        subscribers.map( contact => {
            const exits = currentSchedule?.subscribers?.find( subscriber => subscriber?.contact?.id === contact.id )
            if ( ! exits ) {
                alertsForUpdate.push( {
                    id : null , entityName : "ScheduleReport" , entityId : currentSchedule?.id || entityId , contactId : contact.id , alert : 0 , alertBefore : 0 , alertAfter : 0
                } )
            }

        } )
        let deleteAlerts = null;
        if ( currentSchedule?.subscribers?.length > 0 ) {
            deleteAlerts = currentSchedule?.subscribers?.filter( ( currentSubscriber ) => {
                const result = subscribers?.find( subscriber => subscriber.id === currentSubscriber?.contact?.id );
                if ( ! result ) {
                    return true;
                }
                return false;
            } )
            if ( deleteAlerts ) {
                deleteAlerts = deleteAlerts.map( deleteAlert => ( { id : deleteAlert.id , entityName : "ScheduleReport" } ) )
            }
        }
        dispatch( updateSubscribers( { updateAlerts : alertsForUpdate , deleteAlerts } ) );
    }

    const steps = ( [ messages['reportsMainST_stepGeneral'] , messages['reportsMainST_stepFrequency'] , messages['reportsMainST_stepUnits'] , messages['reportsMainST_stepSubscribers'] ] )

    const includeAllTag = entityTagsSchedule.option?.id == "all";


    const onOptionChangeStatus = ( status ) => {
        entityTagsSchedule.onChange( [] );
        setFormData( { ...formData , tags : [] } );
        entityTagsSchedule.onOptionChangeStatus( status )
        setIncludeInactiveDrivers( status )
    }

    refClearReportSetup.current = handleCancel;
    const entityValues = useMemo(() => {
    if (entityTagsSchedule.option?.id !== 'tags') {
        return entityTagsSchedule.values;
    }
    if (!entityTagsSchedule.values || entityTagsSchedule.values.length === 0) {
        return [];
    }

    return entityTagsSchedule.values.map(v => {
        const numericId = typeof v.id === 'string' ? parseInt(v.id, 10) : v.id;
        const matchingTag = tags?.find(tag => tag.id === numericId);
        return {
            ... v,
            id: numericId,
            color: matchingTag?.color || v.color
        };
        });
    }, [entityTagsSchedule.values, entityTagsSchedule.option?.id, tags]);

    return ( <Modal
        title={ `${ currentSchedule?.newScheduled ? `${ messages['new'] } ` : currentSchedule ? `${ messages['edit'] } ` : '' }${ messages['reportsMainST_scheduleReport'] }` }
        open={ showReportSetup }
        handleClose={ () => handleCancel() }
        size="small"
        position="right"
        className="schedule-report-setup-modal"
        loading={ loading }
    >
        <ModalBody className="schedule-report-container">
            <Stepper
                activeStep={ numberTab }
                steps={ steps }
                className="schedule-report-stepper"
            />
            <div style={ { margin : '0 25px 75px 40px' } }>

                { numberTab === 0 && <Form ref={ selectOptions }
                                           onSubmit={ () => {
                                               const isValidCustomFilters = validCustomFilters( reportType?.id , customFieldsReports.otherFilters );
                                               if ( ! isValidCustomFilters ) {
                                                   setErrorCustomFilters( true )
                                                   return false;
                                               }
                                               return true
                                           } }
                                           onValidSubmit={ handleNext }
                >
                    <Input
                        id='enterLabel'
                        type='text'
                        requiredMessage={ messages['required_field'] }
                        maxLength={ 45 }
                        requiredMin
                        autoFocus
                        required
                        { ...inputNameSchedule }
                    />
                    <div className="schedule-report-accordeon">
                        <Select
                            id="reportType"
                            label={ messages['reportsMainRT_reportType'] }
                            value={ reportType }
                            onChange={ ( type ) => {
                                setReportType( type )
                                setDeliveryList(VIEW_OPTIONS)
                                if ( type?.hideUnits ) {
                                    entityTagsSchedule.hideUnits()
                                } else {
                                    entityTagsSchedule.showAll()
                                }
                                if ( type?.id === 'driverFormsReportV2' || type?.id === 'formStopSummaryReportV2' ) {
                                    dispatch( searchDynamicForms( { ...filters , limit : 0 } ) );
                                }
                                if ( type?.id === 'vehServiceItemsReport' ) {
                                    dispatch( getServiceItemsLegacy( '' ) );
                                }
                                if ( type?.id === 'serviceItemsReport' ) {
                                    dispatch( catalogLoad( [ "maintenanceServicesItems" ] ) );
                                }
                                if ( type?.id === 'unitCertificateReport' ) {
                                    setDeliveryList( VIEW_OPTIONS.filter( option => option.id === 'pdf' ) )
                                }
                                customFieldsReports.restartOtherFilters();
                            } }
                            options={ validatePermissionsReportType }
                            textField="name"
                            valueField="id"
                            placeholder={ messages['reportsMainRT_reportType'] }
                            isClearable
                            required
                            requiredMessage={ messages["generatedReport_selectAReportOption"] }
                            isOptionDisabled={ ( option ) => {
                                return ! option || option.disabled
                            } }
                        />
                    </div>
                    <div className="schedule-report-accordeon">
                        <ReportCustomFields
                            reportType={ reportType }
                            messages={ messages }
                            otherFilters={ customFieldsReports.otherFilters }
                            setOtherFilters={ ( otherFilters ) => {
                                const isValidCustomFilters = validCustomFilters( reportType?.id , otherFilters );
                                if ( isValidCustomFilters ) {
                                    setErrorCustomFilters( false )
                                }
                                customFieldsReports.onChangeOtherFilters( otherFilters )
                            } }
                            selectEventTypeOptions={allOptionEventTypes.sort((a, b) => a.label.localeCompare(b.label))}
                            landmarkTags={ customFieldsReports.tags }
                            getAllLandmarks={ customFieldsReports.getAllLandmarks }
                            landmarkViewOptions={ customFieldsReports.landmarkViewOptions }
                            landmarks={ customFieldsReports.landmarks }
                            landmarkTagsLoading={ customFieldsReports.landmarkTagsLoading }
                            getGeofencesTags={ customFieldsReports.getGeofencesTags }
                            geofenceViewOptions={ customFieldsReports.geofenceViewOptions }
                            geofences={ customFieldsReports.geofences }
                            geofenceTagsLoading={ customFieldsReports.geofenceTagsLoading }
                            driverViewOptions={ customFieldsReports.driverViewOptions }
                            forms={ customFieldsReports.allForms }
                            dynamicForms={ dynamicForms.items }
                            serviceItems={ serviceItems }
                            services={ services }
                            eventTypeVideoOptions={ optionEventTypes }
                            optionsSelectReportType={ optionsSelectReportType }
                            eventFuelLeventOptions={ customFieldsReports.eventFuelLeventOptions }
                        />
                        { errorCustomFilters && <small className="select-error text-danger">{ messages["reportsMainRT_itemsError"] }</small> }
                    </div>
                </Form> }
                { numberTab === 1 && <FrequencyStep
                    scheduleTimeRanges={dataCustomTimeRange.length ? dataCustomTimeRange : (currentSchedule?.scheduleTimeRanges || [])}
                    setStateCustomTimeRange={ setStateCustomTimeRange }
                    validateCustomTimeRanges={ validateCustomTimeRanges }
                    frequency={ frequency }
                    daysIncluded={ selectedDays }
                    deliverOn={ deliverOn }
                    frequencyOptions={ frequencyOptions }
                    daysOptions={ daysOptions }
                    messages={ messages }
                    inputDeliverAt={ inputDeliverAt }
                    deliveryOnList={ deliveryOnList }
                    reportType={ reportType }
                    selectOptions={ selectOptions }
                    errorIncludeDates={ errorIncludeDates }
                    errorDeliveryAt={ errorDeliveryAt }
                    errorDeliverOn={ errorDeliverOn }
                    deliveredOnMonthly={ deliveredOnMonthly }
                    errorDeliveryOnMonthly={ errorDeliveryOnMonthly }
                    onChangeFrequency={ ( value ) => setFrequency( value ) }
                    onChangeSelectDay={ onChangeSelectDay }
                    onChangeDeliverOnMonthly={ onChangeDeliverOnMonthly }
                    onChangeDeliverOn={ onChangeDeliverOn }
                    onChangeDeliveryAt={ onChangeDeliveryAt }
                    onChangeReportType={ ( value ) => setReportType( value ) }
                    handleNext={ handleNext }
                /> }
                { numberTab === 2 && ( <Form ref={ selectOptions }
                                             onSubmit={ () => {
                                                 if ( entityTagsSchedule.values?.length == 0 || ! entityTagsSchedule.values ) {
                                                     if ( includeAllTag ) {
                                                         entityTagsSchedule.onChange( [ { id : -99 , name : entityTagsSchedule.entity?.id } ] )
                                                         setItemsError( false )
                                                     } else {
                                                         setItemsError( true )
                                                         return false
                                                     }
                                                 } else {
                                                     setItemsError( false )
                                                 }
                                                 return true;

                                             } }
                                             onValidSubmit={ handleNext }
                >
                    <EntityUnitDriverSelector
                        {...entityTagsSchedule}
                        values={entityValues}
                        module={'report-module'}
                        onChangeEntity={(newEntity)=> {
                            entityTagsSchedule.onChangeEntity(newEntity)
                            setItemsError(false)
                        }}
                        onOptionChange={(newOption) => {
                            entityTagsSchedule.onOptionChange(newOption)
                            setItemsError(false)
                        }}
                        onOptionChangeStatus={onOptionChangeStatus}
                        entityLabelClass='report-setup-option-label'
                        entityOptionLabelClass='report-setup-type-title'
                        entityTagPickerContainerClass='report-setup-container-tag-picker'
                        ignoreUnitStatus={true}
                        includeUnassignedDriver={reportsUnassignedDriver.includes(reportType?.id)}
                        includeInactiveDrivers={entityTagsSchedule?.includeInactiveDrivers}
                        useIncludesInactive={`${entityTagsSchedule?.entity?.id}-${entityTagsSchedule?.option?.id}`}
                    />
                    { itemsError && <small className="select-error text-danger">{ messages["reportsMainRT_itemsError"] }</small> }
                </Form> ) }
                { numberTab === 3 && <Form ref={ selectOptions }

                                           onSubmit={ () => {
                                               if ( typeof ftp !== "string" && delivery === 'ftp' ) {
                                                   setValidFtp( true )
                                                   return false;
                                               } else if ( ! subscribers?.length && delivery !== "ftp" ) {
                                                   return false
                                               }
                                               return true;
                                           } }

                                           onValidSubmit={ handleNext }>
                    <div style={ { width : '100%' } }>
                        <Grid container direction={ 'row' }>

                            <Grid item sm={ 12 } style={ { marginBottom : 10 , marginTop : 20 } }>
                                <label style={ { fontSize : '12px' } }>{ messages['reportsMainST_selectADeliveryMethod'] }</label>
                            </Grid>

                            { deliveryList.map( ( item , key ) => {
                                const { name , id } = item;
                                const isBehavior = reportType?.id == 'behaviorReport';
                                if ( ! isBehavior || ( isBehavior && item?.id != "json" ) ) {
                                    return ( <Grid item sm={ isBehavior ? 4 : 3 } style={ { padding : 2 } } key={ key }>
                                        <Pill
                                            style={ { width : '100%' } }
                                            item={ { name , color : styles.green } }
                                            colorField="default"
                                            colorSelection="#005bf8"
                                            outlined={ id !== delivery }
                                            onClick={ ( item ) => {
                                                setDelivery( id )
                                            } }
                                        />
                                    </Grid> )
                                }

                            } ) }

                            <Grid item sm={ 12 } style={ { marginBottom : 10 , marginTop : 30 } }>
                                <label style={ { fontSize : '14px' , fontWeight : 'bold' , display : 'block' } }>{ deliveryList.find( item => item.id === delivery ).name }</label>
                                <label style={ {
                                    fontSize : '12px' , fontWeight : 'normal'
                                } }>{ delivery !== "ftp" ? messages['reportsMainST_pleaseSelectARecipientBelow'] : messages['reportsMainST_selectAnFTBServer'] }</label>
                            </Grid>

                            { delivery !== "ftp" ? <Grid item sm={ 12 }>
                                <Select
                                    id="limitToThisTimeFrame"
                                    label={ messages['menu_contacts'] }
                                    value={ subscribers }
                                    onChange={ ( type ) => setSubscribers( type ) }
                                    options={ orderContacts || [] }
                                    textField="title"
                                    valueField="id"
                                    isClearable
                                    selectedOptionsBelow
                                    multiple
                                    required
                                    requiredMessage={ messages["generatedReport_selectAContactOption"] }
                                    placeholder={ messages['select'] }
                                />
                            </Grid> : <FtpForm
                                value={ { ftp , setFtp } }
                                validate={ { validFtp , setValidFtp } }
                                errorMessage={ messages['generatedReportFtpError'] }
                            /> }
                        </Grid>
                    </div>
                </Form> }
            </div>
        </ModalBody>

        <ModalFooter
            styleDiv={ {
                display : 'flex' , justifyContent : 'flex-end' , gap : '10px'
            } }
        >
            <Button
                className='btn-cancel btn-linear'
                onClick={ () => handleCancel() }
            >
                { messages['alertsNewAlert_buttonCancel'] }
            </Button>
            { numberTab > 0 && <Button
                className='btn-border-blue btn-linear'
                onClick={ () => handleBack() }
            >
                { messages['alertsNewAlert_buttonBack'] }
            </Button> }
            <Button
                className="btn-blue btn-linear"
                onClick={ ( event ) => {
                    event.preventDefault();
                    if ( entityTagsSchedule.values?.length == 0 && numberTab === 2 ) {
                        if ( includeAllTag ) {
                            entityTagsSchedule.onChange( [ { id : -99 , name : "Tag" } ] )
                        } else {
                            setItemsError( true )
                            return false
                        }
                    }
                    selectOptions.current.submit();
                } }
            >
                { numberTab === 3 ? ( currentSchedule ? messages['save'] : messages['schedule'] ) : messages['next'] }
            </Button>
        </ModalFooter>

    </Modal> )
}

export default ReportSetup;